import React from 'react';
import { Phone } from 'lucide-react';

export function StickyCallButton() {
  return (
    <a
      href="tel:(855) 513-0871"
      className="fixed bottom-4 right-4 bg-blue-600 text-white rounded-full p-4 shadow-lg hover:bg-blue-700 transition-colors z-50 flex items-center gap-2"
    >
      <Phone className="w-6 h-6" />
      <span className="font-semibold">(855) 513-0871</span>
    </a>
  );
}